import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { Icon } from '@atlas/ui';

import { CDN_TYPE_BASE, imageUrlCDN } from 'common/utils/utils';

const QuickDepositPaymentMethod = ({
  isDropdownOpen,
  paymentMethod,
  setIsDropdownOpen,
  withDropdown,
}) => {
  const { desktopImageLink } = paymentMethod;
  const imageStyle = desktopImageLink
    ? { backgroundImage: `url(${imageUrlCDN(desktopImageLink, CDN_TYPE_BASE)})` }
    : {};
  const props = withDropdown
    ? { onClick: () => setIsDropdownOpen(prev => !prev), role: 'button' }
    : {};

  return (
    <div
      className={cx('quick-deposit-payment-method', {
        open: isDropdownOpen,
        'with-dropdown': withDropdown,
      })}
    >
      <div className="payment-method-wrapper" {...props}>
        <div className="payment-method-image" style={imageStyle}>
          {!desktopImageLink && <Icon name="money" />}
        </div>
        {withDropdown && (
          <Icon className="arrow" name={isDropdownOpen ? 'arrow-up' : 'arrow-down'} />
        )}
      </div>
    </div>
  );
};

QuickDepositPaymentMethod.propTypes = {
  isDropdownOpen: PropTypes.bool,
  paymentMethod: PropTypes.shape({
    desktopImageLink: PropTypes.string,
  }),
  setIsDropdownOpen: PropTypes.func,
  withDropdown: PropTypes.bool,
};

export default QuickDepositPaymentMethod;
